module.exports = __webpack_public_path__ + "static/media/phone.b0a2ba0c.svg";